import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/$orgSlug/admin/ingest")({
  // Component moved to $orgSlug.admin.ingest.lazy.tsx for code splitting
});
